module.exports = require("@angular/platform-server");